<template>
    <div>
        <input type="hidden" v-model="tagsLength" />
        <div ref="tagsWrapper" :class="`tags-wrapper ${classes} ${disabled ? 'disabled' : ''}`">
            <template v-if="showUserConflict"
                ><div class="tags-item d-flex align-items-center" v-for="tag of tags" :key="tag.value">
                    <div class="d-flex flex-column">
                        <span v-if="!showTagsByValue" class="fs-md"> {{ tag.name }}</span>
                        <template v-else>{{ tag.value }} </template>
                        <small :class="`${tag.isAvailable ? 'text-success' : 'text-danger'}`">{{ tag.message }}</small>
                    </div>
                    <i
                        class="fa fa-times ms-2 cursor-pointer fa-lg"
                        @click="removeTag(tag)"
                        v-if="!disabled && showRemoveTag"
                    ></i>
                </div>
            </template>
            <span v-else class="tags-item" v-for="tag of tags" :key="tag.value">
                <template v-if="!showTagsByValue"> {{ tag.name }}</template>
                <template v-else>{{ tag.value }} </template>
                <i class="fas fa-times-circle tags-close" @click="removeTag(tag)" v-if="!disabled && showRemoveTag"></i>
            </span>
            <section class="tags-input">
                <TypeaheadInput
                    :open-on-focus="openOnFocus"
                    ref="typeaheadInputRef"
                    :getData="getData"
                    :data="tagsData"
                    :value="value"
                    v-on:valueChanged="updateValue"
                    :placeholder="placeholder"
                    :close-on-selection="closeOnSelection"
                    :disabled="disabled"
                    :hide-icon="true"
                    :results-limit="resultsLimit"
                    :showAllByDefault="true"
                    v-if="!displayOnly"
                    v-on:blurredInput="emitBlur"
                    :isForMessaging="isForMessaging"
                    :focusOnInput="focusOnInput"
                />
                <slot></slot>
            </section>
        </div>
    </div>
</template>

<style src="./TagsInput.scss"></style>
<script src="./TagsInput"></script>
